import { ArrowForward, Article } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { DangerousGoodsFormField } from "./DangerousGoodsFormField";

export const DangerousGoodsInfo = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Article style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Information")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <DangerousGoodsFormField label={t("Code")} type="text" code="Code" data={dataState} setData={setDataState} />
            <DangerousGoodsFormField label={t("Name")} type="text" code="Name" data={dataState} setData={setDataState} />
            <DangerousGoodsFormField label={t("Description")} type="text" code="Description" data={dataState} setData={setDataState} />
            <DangerousGoodsFormField label={t("Class")} type="text" code="Class" data={dataState} setData={setDataState} />
            <DangerousGoodsFormField label={t("Risk")} type="text" code="Risk" data={dataState} setData={setDataState} />
            <DangerousGoodsFormField label={t("PackageA")} type="text" code="Package_A" data={dataState} setData={setDataState} />
            <DangerousGoodsFormField label={t("PackageB")} type="text" code="Package_B" data={dataState} setData={setDataState} />
            <DangerousGoodsFormField label={t("Comments")} type="text" code="Comments" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}